import React from 'react';
import { connect } from 'react-redux';
import { List, ListItem } from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';
import Avatar from 'material-ui/Avatar';
import Button from '../../../../ui/button';
import { confirmKSFlowItems } from '../../../../../redux/kickstarter-shipping/kickstarter-shipping.actions';
import classes from '../../kickstarter-shipping-popup.scss';
class KickstarterShippingFulfillmentSelector extends React.Component {
  constructor(...args) {
    // @ts-ignore
    super(...args);
    const items = this.props.items || [];
    this.state = {
      items: [].concat(items),
      confirmEnabled: items.some(item => !!item.ksFlow)
    };
    this.checkKSFlow = this.checkKSFlow.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const newItems = nextProps.items || [];
    this.setState({
      items: [].concat(newItems),
      confirmEnabled: newItems.some(item => !!item.ksFlow)
    });
  }
  onConfirm() {
    const {
      items
    } = this.state;
    const ksFlowItems = items.filter(item => !!item.ksFlow);
    if (ksFlowItems.length === 0) {
      return;
    }
    this.props.confirmKSFlowItems(ksFlowItems);
    this.props.onChangeStep(this.props.nextStep);
  }
  checkKSFlow(index) {
    return () => {
      const {
        items
      } = this.state;
      items[index].ksFlow = !items[index].ksFlow;
      this.setState({
        items,
        confirmEnabled: items.some(item => !!item.ksFlow)
      });
    };
  }
  renderItems() {
    const {
      items
    } = this.state;
    return items.map((item, i) => /*#__PURE__*/React.createElement(ListItem, {
      key: i,
      primaryText: item.prod.name,
      leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
        src: item.prod.variants[item.variants[0].variantIndex].images[item.sizeInd].front.url
      }),
      onClick: this.checkKSFlow(i),
      rightIcon: /*#__PURE__*/React.createElement(Checkbox, {
        checked: item.ksFlow || false,
        iconStyle: {
          fill: '#14E06E'
        }
      })
    }));
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "content-root"
    }, /*#__PURE__*/React.createElement("section", {
      className: classes.popupHeader
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.KSLabel
    }, "KICKSTARTER")), /*#__PURE__*/React.createElement("section", {
      className: classes.popupContent
    }, /*#__PURE__*/React.createElement("p", null, "Select which t-shirts are going to be sent to your list of backers."), /*#__PURE__*/React.createElement(List, null, this.renderItems())), /*#__PURE__*/React.createElement("div", {
      className: classes.popupActions
    }, /*#__PURE__*/React.createElement(Button, {
      className: classes.proposals_applyBtn,
      onClick: this.onConfirm,
      disabled: !this.state.confirmEnabled
    }, /*#__PURE__*/React.createElement("span", null, "Confirm"))));
  }
}

// {isLoading
//   ? <CircularProgress className={classes.loader} color={'#fff'} size={0.5} />
//   : null
// }

const selectTshirts = state => state.cart.items.filter(item => `${item.prod.type}` === '1');
const mapStateToProps = state => ({
  items: selectTshirts(state)
});
const mapDispatchToProps = dispatch => ({
  confirmKSFlowItems: items => {
    dispatch(confirmKSFlowItems(items));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(KickstarterShippingFulfillmentSelector);